import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-footer-button',
  templateUrl: './footer-button.component.html',
  styleUrls: ['./footer-button.component.scss'],
})
export class FooterButtonComponent implements OnInit {
  @Input() iconName: string = 'information-circle-outline';
  @Input() color: string = '';
  @Input() label: string = 'Default';
  @Input() badgeStr: string = '';

  @Output() click: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {

  }

  propagateClick($clickEvent) {
    this.click.emit(true);
  }

}
